import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-367a5998"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "balances" };
const _hoisted_2 = { class: "content currency" };
const _hoisted_3 = { class: "content not_currency" };
const _hoisted_4 = { class: "content not_currency" };
import { decimalize } from '@/logics/utils';
import { useStore } from '@/store/store';
import { computed } from 'vue';
import NoData from '@/materials/atoms/NoData.vue';
export default /*#__PURE__*/ _defineComponent({
    props: {
        isShowZero: { type: Boolean },
        list: null
    },
    setup(__props) {
        const props = __props;
        const store = useStore();
        const showList = computed(() => props.list.filter((l) => props.isShowZero || Number(l.balance) !== 0));
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(showList), (balance, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                        key: index,
                        class: "list"
                    }, [
                        _createElementVNode("div", _hoisted_2, _toDisplayString(balance.currency), 1),
                        _createElementVNode("div", _hoisted_3, _toDisplayString(_unref(decimalize)(balance.balance, balance.symbol, _unref(store).state.currencyInfo, true)), 1),
                        _createElementVNode("div", _hoisted_4, _toDisplayString(_unref(decimalize)(balance.onHold, balance.symbol, _unref(store).state.currencyInfo, true)), 1)
                    ]));
                }), 128)),
                _createVNode(NoData, {
                    "is-show": _unref(showList).length === 0
                }, null, 8, ["is-show"])
            ]));
        };
    }
});
